import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=79ac051a&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=79ac051a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac051a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ac051a')) {
      api.createRecord('79ac051a', component.options)
    } else {
      api.reload('79ac051a', component.options)
    }
    module.hot.accept("./TaskList.vue?vue&type=template&id=79ac051a&scoped=true&", function () {
      api.rerender('79ac051a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/TaskList.vue"
export default component.exports